import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import I18n from 'I18n';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCallback } from 'react';
import { Route } from 'react-router-dom';
import FloatingAlertStore from 'UIComponents/alert/FloatingAlertStore';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIModal from 'UIComponents/dialog/UIModal';
import { H2 } from 'UIComponents/elements/headings';
import UILink from 'UIComponents/link/UILink';
import { useClaimProfile } from '../userQueries';
import { hardNavigate, hubspotEditPagePaths, paths } from '../../../utils/urls';
import UIImage from 'UIComponents/image/UIImage'; // @ts-expect-error cannot find module

import NetworkIntroductionImage from 'bender-url!./network-introduction.png';
import { useUserInfo } from '../../auth/authQueries';

const ClaimProfile = () => {
  const {
    userInfo: hubspotUser
  } = useUserInfo();
  const {
    claimProfile
  } = useClaimProfile();
  const goToClaim = useCallback(() => {
    hardNavigate(hubspotEditPagePaths.claim());
  }, []);
  const goToDirectory = useCallback(() => {
    hardNavigate(hubspotEditPagePaths.directory());
  }, []);
  const hideIntroductionModal = useCallback(() => {
    hardNavigate(hubspotEditPagePaths.directory());
  }, []);
  const handleClaimProfile = useCallback(() => {
    if (hubspotUser) {
      claimProfile({
        variables: {
          userId: hubspotUser.user_id
        }
      }).then(() => {
        hardNavigate(hubspotEditPagePaths.edit());
      }).catch(() => {
        FloatingAlertStore.addAlert({
          message: I18n.text('connectDotCom.claimFail'),
          type: 'danger'
        });
      });
    }
  }, [claimProfile, hubspotUser]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Route, {
      path: paths.INTRODUCTION,
      children: /*#__PURE__*/_jsxs(UIModal, {
        width: 650,
        children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
          children: [/*#__PURE__*/_jsx(H2, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "connectDotCom.connectModalTitle"
            })
          }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
            onClick: hideIntroductionModal
          })]
        }), /*#__PURE__*/_jsxs(UIDialogBody, {
          children: [/*#__PURE__*/_jsx("p", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "connectDotCom.connectModalDescription"
            })
          }), /*#__PURE__*/_jsx(UIImage, {
            src: NetworkIntroductionImage,
            width: 330,
            height: 235,
            className: "m-x-auto"
          })]
        }), /*#__PURE__*/_jsx(UIDialogFooter, {
          children: /*#__PURE__*/_jsx(UIButton, {
            use: "primary",
            href: hubspotEditPagePaths.claim(),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "connectDotCom.getStarted"
            })
          })
        })]
      })
    }), /*#__PURE__*/_jsx(UIButton, {
      "data-test-id": "join-connect-button",
      use: "primary",
      onClick: goToClaim,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "connectDotCom.join"
      })
    }), /*#__PURE__*/_jsx(Route, {
      path: paths.CLAIM,
      children: /*#__PURE__*/_jsxs(UIModal, {
        "data-test-id": "claim-profile-terms-modal",
        width: 650,
        children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
          children: [/*#__PURE__*/_jsx(H2, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "connectDotCom.termsTitle"
            })
          }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
            onClick: goToDirectory
          })]
        }), /*#__PURE__*/_jsx(UIDialogBody, {
          children: /*#__PURE__*/_jsx("p", {
            children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
              message: "connectDotCom.termsBody_jsx",
              elements: {
                Link: UILink
              },
              options: {
                privacyPolicyLink: 'https://legal.hubspot.com/privacy-policy',
                termsOfUseLink: 'https://legal.hubspot.com/connect-tou'
              }
            })
          })
        }), /*#__PURE__*/_jsxs(UIDialogFooter, {
          children: [/*#__PURE__*/_jsx(UIButton, {
            "data-test-id": "claim-profile-agree-button",
            use: "primary",
            onClick: handleClaimProfile,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "connectDotCom.agree"
            })
          }), /*#__PURE__*/_jsx(UIButton, {
            onClick: goToDirectory,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "connectDotCom.cancel"
            })
          })]
        })]
      })
    })]
  });
};

export default ClaimProfile;